module.exports = __webpack_public_path__ + "static/img/news_tu4.c86d4da.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/news_tu4.png
// module id = J36E
// module chunks = 0